<template>
    <div class="container remove-padding">
        <div class="header-top bg-white">
            <div class="nav-center">
                <div class="row set-row d-flex w-limit">
                    <div class="remove-padding navbar-icon-left" @click="back">
                        <img class="remove-padding-margin" @click="" src="../../assets/gambar/back-blue.svg">
                    </div>
                    <div class="text-center remove-padding flex-1 font-weight-600">
                        Detail Rak
                    </div>
                    <div class="navbar-icon-right remove-padding">

                    </div>
                </div>
            </div>
        </div>
        <main class="w-limit">
            <div class="flex-100">
                <div class="pad-top-66">
                    <div class="animasi-card  bg-transparent d-flex m-d-4 add-padding-default">
                        <div class="f-12"><span v-if="tagrak != ''" class="color-6f7">{{tagrak}}</span></div>
                    </div>
                    <div class="add-padding-default m-d-12 border-bottom">
                        <div class="font-18 font-weight-600 letter-space-002 line-height-28 color-0000 m-d-12">{{namarakedit}}</div>
                    </div>
	                <div class="add-padding-default m-d-12">
		                <p class="font-14 f-c-midgrey m-0">
			                <span>{{ sum_isi.lipat }} Pack Lipatan<span class="m-l-4 m-r-4">•</span></span>
			                <span>{{ sum_isi.gantung }} Gantungan<span class="m-l-4 m-r-4">•</span></span>
			                <span>{{ sum_isi.gulung }} Gulungan</span>
		                </p>
	                </div>
                </div>
	            <div class="flex-1 bg-grey add-padding-default" v-if="listTransaksi.length">
		            <p class="p-y-16 m-0 f-c-midgrey">
			            Isi Rak ({{ listTransaksi.length }} Nota)
		            </p>

                <template>
                    <div class="set-card pb-0" v-for="item in listTransaksi" :key="item.idtransaksi">
                    <div class="row add-padding-default">
                        <div class="col-md-12 col-sm-12 col-12 remove-padding">
                            <div class="font-16 m-d-4 font-weight-bold nomore capitalize">
                            {{ item.detailTransaksi.customer.nama }}
                            <div class="f-14 f-semi">
                                {{ item.detailTransaksi.customer.telp }}
                            </div>
                            </div>
                            <div class="font-16 remove-margin nomore capitalize addressstyle">
                                <div v-for="layanan, index in mergedLayanan(item.layanan)" :key="index">
                                    <p class="m-d-4 f-14 f-c-midgrey" v-if="layanan.lipat">{{ layanan.lipat }} Pack Lipatan <span class="f-bold">{{ layanan.detlayanan.data_layanan.nama_layanan }}</span>  </p>
                                    <p class="m-d-4 f-14 f-c-midgrey" v-if="layanan.gantung">{{ layanan.gantung }} Gantungan <span class="f-bold">{{ layanan.detlayanan.data_layanan.nama_layanan }}</span> </p>
                                    <p class="m-d-4 f-14 f-c-midgrey"  v-if="layanan.gulung">{{ layanan.gulung }} Gulung <span class="f-bold">{{ layanan.detlayanan.data_layanan.nama_layanan }}</span> </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row add-padding-default" style="border-top: 1px solid rgba(0, 0, 0, 0.07);">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-6 pl-0 pr-0" style="padding: 6px 0">
                        <div class="f-12 f-c-midgrey nomore capitalize" >
                            {{ item.idtransaksi }}
                        </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-6 pl-0 pr-0 text-right" style="padding: 6px 0">
                        <div class="f-c-midgrey f-12 m-d-4" >oleh {{ item.detailTransaksi.karyawan.nama }}</div>
                        </div>
                    </div>
                    </div>
                </template>
	            </div>
            </div>
        </main>
    </div>
</template>

<script>
    export default {
        name: "DetailRak",
        props:['setidoutletserak','dataidrak'],
        data(){
            return{
                suggestarrayeditrak:[],
                namarakedit:'',
                tagrak:'',
	            sum_isi: {
                	gantung: 0,
		            gulung: 0,
		            lipat: 0,
	            },
	            listTransaksi: [],
                isClicked:false,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
            }
        },
        mounted() {
            this.getdetailraks();
        },
        methods:{
            back(){
                this.$emit('back')
            },
            async getdetailraks(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_rak_meta?idrak=' + this.dataidrak.idrak,this.requestHeaders);
                    if(response.data.status===true){
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        var detailraks = response.data.data;
                        this.namarakedit= detailraks.nama;

                        if (detailraks.rak_kategori != null){
                            this.tagrak = detailraks.rak_kategori.nama;
                        }else{
                            this.tagrak = "-"
                        }
                        
                        this.sum_isi.gantung = detailraks.isi_gantung
	                    this.sum_isi.gulung = detailraks.isi_gulung
	                    this.sum_isi.lipat = detailraks.isi_lipat
                        
                        const idTransaksis = [...new Set(detailraks.transaksi_rak.map(item => item.idtransaksi))];

                        const transaksiRak = []

                        idTransaksis.forEach(element => {

                            const layanan = detailraks.transaksi_rak.filter(item => item.idtransaksi === element);
                            delete layanan.transaksi
                            transaksiRak.push({
                                idtransaksi: element,
                                detailTransaksi: detailraks.transaksi_rak.find(item => item.idtransaksi === element).transaksi,
                                layanan: layanan,
                            })
                        });

                        
                        
	                    this.listTransaksi = transaksiRak
                        console.log(this.listTransaksi);
                        
                        $('#suggestDataRak').val(this.tagrak).trigger('change');
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
            mergedLayanan(layanan) {
                return layanan.reduce((acc, item) => {
                    const existingItem = acc.find(i => i.ref_iddetlayanan === item.ref_iddetlayanan);
                    if (existingItem) {
                        existingItem.gantung += item.gantung;
                        existingItem.gulung += item.gulung;
                        existingItem.lipat += item.lipat;
                    } else {
                        acc.push({ ...item }); // Jika belum ada, tambahkan ke array baru
                    }
                    return acc;
                }, []);
            }
        }
    }
</script>

<style scoped>

</style>